import { useState } from "react";
import Box from "@mui/material/Box";
import ModalBasicLayout from "../../../components/Modal/ModalBasicLayout";
import ContainerModalActions from "../../../components/Containers/ContainerModalActions";
import TextField from "../../../components/Form/TextField";
import { useForm } from "react-hook-form";
import { useTranslationApp } from "../../../lib/i18next";
import { useDispatchApp } from "../../../lib/redux";
import { startAddAdvertiserToAgency } from "../../../actions/owner";
import { SimpleAlert } from "../../../components/Alerts/Alerts";
import {
  ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_TITLE,
  ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_BRAND_NAME_LABEL,
  ADMIN_DASHBOARD_ADVERTISER_CREATED_SUCCESS,
  BUTTON_CANCEL,
  BUTTON_SAVE,
  FIELD_REQUIRED,
} from "../../../i18n/keysTranslations";

const ModalAddAdvertiser = ({
  modalOpen,
  onCloseModal,
  agencyID,
  onCallbackSave = () => {},
}) => {
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      businessName: "",
    },
  });

  const onSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      const response = await dispatch(
        startAddAdvertiserToAgency(agencyID, values.businessName)
      );

      if (response?.ok) {
        await onCallbackSave(response.data);

        await SimpleAlert({
          title: t(ADMIN_DASHBOARD_ADVERTISER_CREATED_SUCCESS),
          icon: "success",
        });

        reset();
        onCloseModal();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      title={t(ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_TITLE)}
      maxWidth="sm"
      fullWidth
      showCloseButton={true}
    >
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
        }}
      >
        <TextField
          fullWidth
          label={t(ADMIN_DASHBOARD_ADD_ADVERTISER_MODAL_BRAND_NAME_LABEL)}
          name="businessName"
          variant="filled"
          color="primary"
          InputLabelProps={{ shrink: true }}
          control={control}
          rules={{
            required: {
              value: true,
              message: t(FIELD_REQUIRED),
            },
          }}
          errors={errors}
        />

        <ContainerModalActions
          hasPadding={false}
          propsSecondaryButton={{
            showButton: true,
            text: BUTTON_CANCEL,
            onClick: onCloseModal,
          }}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_SAVE,
            loading: isSubmitting,
            type: "submit",
            onClick: () => {},
          }}
        />
      </Box>
    </ModalBasicLayout>
  );
};

export default ModalAddAdvertiser;
